import { useSelector } from 'react-redux';

import { selectCurrentNode } from '@/modules/tryIt/redux/selectors';
import { selectBrainId } from '@/redux/session/selectors';

/**
 * Brain that handled the selected turn (multi-brain sessions route each turn to a
 * different brain); falls back to the session brain, then the log's parent brain.
 */
export const useTurnBrainId = (logBrainParentId?: string | null) => {
  const node = useSelector(selectCurrentNode);
  const sessionBrainId = useSelector(selectBrainId);
  return (node?.author_type === 'brain' && node.author_id) || sessionBrainId || logBrainParentId;
};
